/// Contract addresses — populated after deployment
/// In production, these come from environment variables baked at build time.

export const CONTRACTS = {
  USDT: import.meta.env.VITE_USDT_ADDRESS || "0x55d398326f99059fF775485246999027B3197955",
  CROWN_REGISTRY: import.meta.env.VITE_CROWN_REGISTRY_ADDRESS || "",
  CROWN_VAULT: import.meta.env.VITE_CROWN_VAULT_ADDRESS || "",
  CROWN_BETTING: import.meta.env.VITE_CROWN_BETTING_ADDRESS || "",
  CROWN_ODDS_AMM: import.meta.env.VITE_CROWN_ODDS_AMM_ADDRESS || "",
  CROWN_SETTLEMENT: import.meta.env.VITE_CROWN_SETTLEMENT_ADDRESS || "",
  CROWN_COMMISSION: import.meta.env.VITE_CROWN_COMMISSION_ADDRESS || "",
  CROWN_FORWARDER: import.meta.env.VITE_CROWN_FORWARDER_ADDRESS || "",
  CROWN_AAVE_ADAPTER: import.meta.env.VITE_CROWN_AAVE_ADAPTER_ADDRESS || "",
  CROWN_PAYMASTER: import.meta.env.VITE_CROWN_PAYMASTER_ADDRESS || "",
} as const;

export const API_URL = import.meta.env.VITE_API_URL || "http://localhost:3001/api";
